import axios from 'axios'

export default {
  namespaced: true,
  actions: {
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request', null, {
          root: true,
        })
        axios({
          url: process.env.VUE_APP_URL + '/login/webadmin',
          data: user,
          method: 'POST',
        })
          .then((response) => {
            const isSuperAdmin =
              response.data.entity.userType === 'SA' ? true : false
            const token = response.data.entity.accessToken
            const user = user
            localStorage.setItem('token', token)
            axios.defaults.headers.common['Authorization'] = token
            axios.defaults.headers.common['Content-Type'] = 'application/json'

            if (isSuperAdmin) {
              localStorage.setItem('isSA', true)
              axios.defaults.headers.common['userType'] = 'SA'
            } else {
              localStorage.removeItem('isSA')
              axios.defaults.headers.common['userType'] = 'W'
            }

            commit(
              'auth_success',
              {
                token: token,
                user: user,
                isSuperAdmin: isSuperAdmin,
              },
              {
                root: true,
              }
            )
            resolve(response)
          })
          .catch((error) => {
            commit('auth_error', null, {
              root: true,
            })
            localStorage.removeItem('token')
            localStorage.removeItem('isSA')
            reject(error)
          })
      })
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/logout/webadmin',
          data: {},
          method: 'PUT',
        })
          .then((response) => {
            commit('logout', null, {
              root: true,
            })
            localStorage.removeItem('token')
            delete axios.defaults.headers.common['Authorization']
            delete axios.defaults.headers.common['Content-Type']
            axios.defaults.headers.common['Content-Type'] =
              'application/x-www-form-urlencoded'

            if (localStorage.getItem('isSA')) {
              localStorage.removeItem('isSA')
              delete axios.defaults.headers.common['userType']
            }
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    forceLogout({ commit }) {
      commit('logout', null, {
        root: true,
      })
      localStorage.removeItem('token')
      delete axios.defaults.headers.common['Authorization']
      delete axios.defaults.headers.common['Content-Type']
      axios.defaults.headers.common['Content-Type'] =
        'application/x-www-form-urlencoded'

      localStorage.removeItem('isSA')
      delete axios.defaults.headers.common['userType']
    },
    sendRecoveryRequest(o, object) {
      return new Promise((resolve, reject) => {
        axios({
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          url:
            process.env.VUE_APP_URL + '/login/webadminnewpasswordfromrecover',
          data: object,
          method: 'POST',
        })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    verifyCode(o, object) {
      return new Promise((resolve, reject) => {
        axios({
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          url:
            process.env.VUE_APP_URL +
            '/login/webadminnewpasswordfromrecoververify',
          data: object,
          method: 'POST',
        })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    changePasswordRequest(o, object) {
      return new Promise((resolve, reject) => {
        axios({
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          url:
            process.env.VUE_APP_URL +
            '/login/webadminnewpasswordfromrecoveryupdate',
          data: object,
          method: 'POST',
        })
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    readCodeThirdQR(o, object) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/login/thirdQrReadCode',
          data: object,
          method: 'POST',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    generateQR(o, object) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/login/generateThirdQr',
          data: object,
          method: 'POST',
        })
          .then((response) => {
            if (response.data.status) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    logoutSA({ commit }) {
      return new Promise((resolve, reject) => {
        axios({
          url: process.env.VUE_APP_URL + '/logout/sa',
          data: {},
          method: 'PUT',
        })
          .then((response) => {
            commit('logout', null, {
              root: true,
            })
            localStorage.removeItem('token')
            delete axios.defaults.headers.common['Authorization']
            delete axios.defaults.headers.common['Content-Type']
            axios.defaults.headers.common['Content-Type'] =
              'application/x-www-form-urlencoded'

            if (localStorage.getItem('isSA')) {
              localStorage.removeItem('isSA')
              delete axios.defaults.headers.common['userType']
            }
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
}
